@use '../../../src/styles/Colors.scss' as Colors;
@use '../../../src/styles/Constants.scss' as Constants;

.label {
	font-weight: bold;
}

.icon {
	margin-right: Constants.$val-spacing-s;
}

.grey {
	color: Colors.$col-greyFontLight;
}

.blue {
	color: Colors.$col-darkBlueBorder;
}

.green {
	color: Colors.$col-green;
}

.orange {
	color: Colors.$col-orange;
}